export const PERMIS_LESSONS = [
  {
    id: 'permis-1',
    numero: 1,
    titre: "Comprendre les démarches permis",
    sousTitre: "ANTS, auto-école, financement",
    contexte: "Marie veut passer son permis de conduire. Elle ne sait pas par où commencer ni quels documents rassembler.",
    explication: [
      "Toutes les démarches permis passent par le site **ANTS** (Agence Nationale des Titres Sécurisés) : **ants.gouv.fr**",
      "Première étape : s'inscrire au **code de la route** via une auto-école agréée ou un centre agréé (Codes Rousseau, en ligne…).",
      "Il faut fournir : **pièce d'identité, justificatif de domicile, photo d'identité numérique** et un **ASSR ou ASR** (attestation sécurité routière).",
      "Le **permis B classique** coûte en moyenne 1 500 à 1 800 €. Le **CPF** peut financer une partie (cherchez 'permis B' sur moncompteformation.gouv.fr).",
      "L'**AAC (conduite accompagnée)** à partir de 15 ans permet de passer le permis plus vite et moins cher.",
    ],
    question: "Sur quel site effectue-t-on les démarches officielles pour le permis de conduire ?",
    options: [
      { id: 'a', text: "impots.gouv.fr", correct: false },
      { id: 'b', text: "ants.gouv.fr", correct: true },
      { id: 'c', text: "ameli.fr", correct: false },
    ],
    explication_reponse: "L'ANTS centralise toutes les démarches liées aux titres de transport : permis, carte grise, certificat d'immatriculation.",
  },
  {
    id: 'permis-2',
    numero: 2,
    titre: "Passer l'examen du code",
    sousTitre: "S'inscrire, préparer, réussir",
    contexte: "Marie a trouvé une auto-école. L'examinateur du code arrive dans 3 semaines. Elle veut savoir comment se préparer.",
    explication: [
      "L'examen du code comporte **40 questions** en 30 minutes — il faut au moins **35 bonnes réponses** pour réussir.",
      "Vous pouvez vous entraîner gratuitement sur des sites comme **codedelaroute.fr** ou des applications mobiles.",
      "L'inscription à l'examen est gérée par l'auto-école — elle réserve votre place auprès des services de l'État.",
      "En cas d'échec, vous pouvez **repasser sans délai minimum** — chaque tentative coûte environ 30 €.",
      "Une fois le code obtenu, il est **valable 5 ans** pour passer la conduite.",
    ],
    question: "Combien de bonnes réponses faut-il pour réussir l'examen du code ?",
    options: [
      { id: 'a', text: "30 sur 40", correct: false },
      { id: 'b', text: "35 sur 40", correct: true },
      { id: 'c', text: "40 sur 40", correct: false },
    ],
    explication_reponse: "35 bonnes réponses sur 40 sont nécessaires. En cas d'échec, pas de délai d'attente — vous pouvez retenter rapidement.",
  },
  {
    id: 'permis-3',
    numero: 3,
    titre: "Obtenir son permis après l'examen",
    sousTitre: "Résultat, permis provisoire, titre définitif",
    contexte: "Marie vient de réussir l'examen de conduite. Elle ne sait pas ce qui se passe ensuite.",
    explication: [
      "À la sortie de l'examen, l'examinateur vous remet un **résultat provisoire** (réussite ou échec avec points à améliorer).",
      "En cas de réussite, votre auto-école effectue la demande de permis sur **ants.gouv.fr** en votre nom.",
      "Vous recevez d'abord un **permis provisoire papier** valable 4 mois, le temps que le titre plastifié soit fabriqué.",
      "Le **permis définitif** arrive par courrier dans les 2 à 3 semaines suivant la réussite.",
      "Le **permis probatoire** dure 3 ans : départ à 6 points, +3 points par an sans infraction jusqu'à 12 points.",
    ],
    question: "Combien de points a-t-on sur son permis les 3 premières années ?",
    options: [
      { id: 'a', text: "12 points dès le départ", correct: false },
      { id: 'b', text: "6 points au départ, avec une montée progressive", correct: true },
      { id: 'c', text: "0 point — il faut tout gagner", correct: false },
    ],
    explication_reponse: "Le permis probatoire démarre à 6 points. Vous gagnez 3 points par année sans infraction, jusqu'à 12 points au bout de 3 ans.",
  },
  {
    id: 'permis-4',
    numero: 4,
    titre: "Démarches en ligne : perte, vol, renouvellement",
    sousTitre: "Tout se fait sur ants.gouv.fr",
    contexte: "Marie a perdu son permis. Elle ne sait pas comment en obtenir un duplicata sans aller en préfecture.",
    explication: [
      "En cas de **perte ou vol**, déclarez-le sur **ants.gouv.fr** — vous obtenez un récépissé immédiat valable 2 mois.",
      "La demande de **duplicata** se fait entièrement en ligne : photos, justificatifs, paiement (25 €) — plus besoin de préfecture.",
      "Le permis est aussi à **renouveler** si vous changez de nom, d'adresse (optionnel), ou en cas de détérioration.",
      "Pour **récupérer des points** perdus : suivre un stage de sensibilisation à la sécurité routière (4 points max, tous les 2 ans).",
      "En cas de **suspension ou annulation**, un médecin agréé doit valider votre aptitude avant toute réinscription.",
    ],
    question: "Où faire une demande de duplicata de permis en cas de perte ?",
    options: [
      { id: 'a', text: "En se rendant en préfecture", correct: false },
      { id: 'b', text: "Sur ants.gouv.fr, entièrement en ligne", correct: true },
      { id: 'c', text: "À la mairie de son domicile", correct: false },
    ],
    explication_reponse: "Depuis 2017, la plupart des démarches permis se font en ligne sur ants.gouv.fr. Les préfectures n'acceptent plus les dossiers papier pour ces demandes.",
  },
];
